var BSessionStorage = (function () {
    function BSessionStorage() {
        BSessionStorage.sessionStorageCache = sessionStorage;
    }
    BSessionStorage.prototype.getSessionStorage = function () {
        return BSessionStorage.sessionStorageCache;
    };
    BSessionStorage.prototype.setValue = function (key, value) {
        BSessionStorage.sessionStorageCache[key] = value;
        sessionStorage.setItem(key, value);
    };
    BSessionStorage.prototype.getValue = function (key) {
        if (!BSessionStorage.sessionStorageCache[key]) {
            return null;
        }
        try {
            var obj = BSessionStorage.sessionStorageCache[key];
            return JSON.parse(obj);
        }
        catch (error) {
            return BSessionStorage.sessionStorageCache[key];
        }
    };
    BSessionStorage.prototype.remove = function (key) {
        if (BSessionStorage.sessionStorageCache.hasOwnProperty(key)) {
            delete BSessionStorage.sessionStorageCache[key];
            sessionStorage.removeItem(key);
        }
    };
    BSessionStorage.prototype.clearSessionStorage = function () {
        BSessionStorage.sessionStorageCache = {};
        sessionStorage.clear();
    };
    BSessionStorage.sessionStorageCache = {};
    return BSessionStorage;
}());
export { BSessionStorage };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bSessionStorage.service.ts.pre-build-optimizer.js